<template>
<div id="app">
  <v-dialog width="1000" v-model="show">
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('archive.add-file') }}
      </v-card-title>
      <v-container>
        <div>
          <v-select :items="schemas" item-text="name" item-value="id" v-model="schema" label="Schemat"></v-select>
          <v-btn @click="upload()">{{$t('archive.upload')}}</v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
  <v-layout row>
    <v-flex xs12 sm12>
      <v-card>
        <v-toolbar color="cyan" dark>
          <v-toolbar-title>{{$t('form.upload.assign-lines')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list two-line>
          <template v-for="(item, index) in dataFile">
            <v-list-tile :key="item" @click="chooseSchema(index)">
              <v-list-tile-content>
                <v-list-tile-title v-html="item"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import http from '@/plugins/http'
export default {
  props: ['dataFile', 'separator'],
  data() {
    return {
      createDialog: false,
      show: false,
      current: 0,
      schema: null,
      schemas: []
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams
    }
  },
  created() {
    this.loadSchemas()
  },
  methods: {
    chooseSchema(current) {
      this.show = true
      this.current = current
    },
    upload() {
      if (!this.schema)
        return
      this.loading = true
      var file = new Blob([this.dataFile[this.current]], {
        type: 'text/plain'
      });
      const json = JSON.stringify(this.$parent.$parent.$parent.$parent.getMap());

      let formData = new FormData();
      formData.append('file', file);
      formData.append('map', json);
      formData.append('skipFirstRow', false);
      formData.append('separator', this.separator);


      http.post('form/' + this.schema + '/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        this.$emit('slice', this.current)
        this.current = null
        this.$store.commit("setSnack", {
          message: this.$t('base.done').toUpperCase(),
          color: "success",
        })

      }).catch(() => {
        this.loading = false
        this.$store.commit("setSnack", {
          message: this.$t('archive.upload_error'),
          color: "danger",
        })
      }).finally(() => {
        this.loading = false
        this.show = false

      })
    },
    loadSchemas() {
      this.loading = true;
      http.get('schemas')
        .then(response => {
          this.schemas = response.data;
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
</style>
